var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "grid",
    class: ("grid_" + (_vm.largeCount) + "-large")
  }, _vm._l(_vm.shrinkedList, function (el, index) {
    return _c('div', {
      key: index,
      staticClass: "grid__el"
    }, [_vm._t("default", null, {
      "el": el,
      "size": index < _vm.largeCount ? 'big' : 'regular'
    })], 2);
  }), 0);
}
var staticRenderFns = []

export { render, staticRenderFns }